import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesRoutingModule } from './pages-routing.module';
import { PagosLineaComponent } from './pagos-linea/pagos-linea.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingComponent } from './components/loading/loading.component';
import { ModalMercadoComponent } from './components/modal-mercado/modal-mercado.component';
import { SanitizeUrlPipe } from 'src/app/pipe/sanitize-url.pipe';


@NgModule({
  declarations: [
    PagosLineaComponent,
    LoadingComponent,
    ModalMercadoComponent,
    SanitizeUrlPipe
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class PagesModule { }
